module.exports = __webpack_public_path__ + "static/grafika14@2x-01062bcd26240c4f3197722c4c10dee3.png";